import React, { useContext } from 'react'
import Link from './elements/link'
import './ArticleNavi.scss'
import GlobalContext from '../global'

function ArticleNavi(props) {
  const global = useContext(GlobalContext)
  return (
    <div className="article-navi-area">
      <div className="article-navi-field back">
        <a
          href=""
          onClick={e => {
            e.preventDefault()
            window.history.back()
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
            <path fill="none" stroke="#E52236" d="M.3535.3534L20.8535 20.8534M.3535 20.8534L20.8535.3534" />
          </svg>
          <span>{global.data.back}</span>
        </a>
      </div>
      {props.related.length > 0 && (
        <Link key={`related-${props.related[0].id}`} type="internal" route={`/${props.related[0].uid}`}>
          <div className="article-navi-field next">
            <a>
              <span>{global.data.next_moment}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="21" viewBox="0 0 13 21">
                <path fill="none" stroke="#E52236" d="M.3578.3534L10.6078 10.6034M.3578 20.8536L10.3608 10.6066" />
              </svg>
            </a>
          </div>
        </Link>
      )}
    </div>
  )
}

export default ArticleNavi
